import * as React from 'react'
import { Button, Label } from '@/shared/ui'

type Props = {
  label: string
  url: string | null
  disabled?: boolean
  onSelect: (f: File) => void
}

export default function LogoUploadField({ label, url, disabled, onSelect }: Props) {
  const inputRef = React.useRef<HTMLInputElement>(null)
  return (
    <div>
      <Label>{label}</Label>
      <div className="mt-2 flex items-center gap-3">
        <div className="flex h-12 w-32 items-center justify-center rounded-md border bg-background">
          {url ? <img src={url} alt="preview" className="max-h-10 w-auto object-contain" /> : <span className="text-xs text-foreground/50">Sem logo</span>}
        </div>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => {
            const f = e.target.files?.[0]
            if (f) onSelect(f)
            if (inputRef.current) inputRef.current.value = ''
          }}
        />
        <Button type="button" variant="secondary" disabled={disabled} onClick={() => inputRef.current?.click()}>
          Selecionar imagem
        </Button>
      </div>
    </div>
  )
}

